import React from 'react'
import { useHistory } from 'react-router-dom';
import SarasAC from '../../input/autocomplete/SarasAutocomplete2'
import * as fn from '../../../helper/uiFunctions';

//this component will be used for autocomplete 
//and upon selection it will redirect to the selected documents url
const FormInputRedirect = (props) => {
    //this should be default format for reading props for all form controls
    const { formObject, action, rowKey, headerKey, ...restProps } = props;
    // console.log('data', rowKey, action.paramName, formObject);

    const history = useHistory();

    //set server side values for auto complete
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const isReadOnly = formObject.getValueFromKey(viewData, "dataList.isRO", "0");

    //pass this handle to the input control and ensure it returns the selected value
    //in case of ac value should contain an object {key: val, text: text to display}
    const onInputChange = (e, value, source) => {
        // console.log("form input redirect changed", value);
        //redirect

        //auto complete event is fired twice sometimes - one on focus out and another on menu click
        //to avoid redirection 2 times, trigger redirect only on menu click
        //TODO this is done till the problem of double trigger is solved
        if(source === "menu"){
            let newUrl = fn.getShowDocumentLink(viewData.dataList.valLDT, value.key, "", 0,
                formObject.getValueFromKey(action, "actionParam.module", ""),
                formObject.getValueFromKey(action, "actionParam.view", ""));
            // console.log("url created", newUrl);
            history.push(newUrl);
        }
    }

    //this is used for AC, where in formula will be passed and its interpreted value will be returned back
    //this function will be used for acMethod (return value string), acDepCtrl (return value object)
    //starting with # means it is like paramName and its value will come from another column of same row
    //starting with % means it is like the key and its value will come from the same column and within that column for matching key
    const onGetDependantValue = (formula) => {
        let params = formObject.getDependantValue(formula, rowKey, headerKey, action.paramName);

        return params;
    };

    const getROValue = () => {
        let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

        if (value === "0")
            value = '';

        return value;
    }

    //render input or ac or dp control from input library based on action.InputType 
    //- see sample usage in PocViewer.js
    //NOTE: do not render label control
    //NOTE: use formObject.getState(action.paramName) to get the value for this input
    if((viewData) && hide === "0"){
        let val = viewData?viewData.val:'';
        let valF = viewData?viewData.valF:'';

        valF = valF || val;

        if(isReadOnly === "1")
        {
            return (
                <span className={`${viewData.dataList ? viewData.dataList.colCssClass : ''}`} {...restProps}>{getROValue()}</span>
            )
        }
        else
        {
            return (
                <SarasAC onChange={onInputChange} value={val} label={valF} {...action}  {...restProps} onGetDependantValue={onGetDependantValue} />
            )
        }
    }

    return (null);
}

export default FormInputRedirect;
